/**
 * Get the appropriate YouTube channel link based on user region
 * @param region - The user's region code
 * @returns YouTube channel URL with subscription confirmation
 */
export function getYouTubeRegionLink(region?: string): string {
  if (!region) {
    return 'https://www.youtube.com/@angelstudiosinc?sub_confirmation=1'
  }

  const upperRegion = region.toUpperCase()

  switch (upperRegion) {
    case 'BR':
      return 'https://www.youtube.com/@AngelStudiosBrasil?sub_confirmation=1'
    case 'IN':
      return 'https://www.youtube.com/@AngelStudiosIndia?sub_confirmation=1'
    case 'ES':
      return 'https://www.youtube.com/@AngelStudiosEspa%C3%B1a?sub_confirmation=1'
    case 'GB':
    case 'IE':
      return 'https://www.youtube.com/@AngelStudiosUK?sub_confirmation=1'
    case 'BE':
    case 'NL':
    case 'LU':
      return 'https://www.youtube.com/@angelbenelux?sub_confirmation=1'
    case 'DE':
    case 'AT':
    case 'CH':
      return 'https://www.youtube.com/@angelstudiosdach?sub_confirmation=1'
    case 'FR':
      return 'https://www.youtube.com/@AngelStudiosFrance?sub_confirmation=1'
    case 'PH':
      return 'https://www.youtube.com/@AngelStudiosPhilippines?sub_confirmation=1'
    case 'AE':
    case 'AO':
    case 'DM':
    case 'BS':
    case 'UV':
    case 'BD':
    case 'CM':
    case 'CX':
    case 'CD':
    case 'CF':
    case 'FT':
    case 'EG':
    case 'ET':
    case 'GO':
    case 'GM':
    case 'GH':
    case 'GV':
    case 'PG':
    case 'IV':
    case 'KE':
    case 'LO':
    case 'LB':
    case 'MG':
    case 'MW':
    case 'ML':
    case 'MU':
    case 'MZ':
    case 'SX':
    case 'NG':
    case 'RW':
    case 'SF':
    case 'SG':
    case 'SL':
    case 'SO':
    case 'SA':
    case 'SJ':
    case 'SQ':
    case 'TZ':
    case 'TG':
    case 'UG':
    case 'SS':
    case 'CG':
    case 'ZA':
    case 'RH':
      return 'https://www.youtube.com/@angelstudiosafrica?sub_confirmation=1'
    case 'AU':
    case 'NZ':
      return 'https://www.youtube.com/@AngelStudiosANZ?sub_confirmation=1'
    case 'KR':
      return 'https://www.youtube.com/@AngelStudiosKorea?sub_confirmation=1'
    case 'AR':
    case 'BZ':
    case 'BO':
    case 'CL':
    case 'CO':
    case 'CR':
    case 'CU':
    case 'DO':
    case 'EC':
    case 'SV':
    case 'FK':
    case 'GT':
    case 'GY':
    case 'HN':
    case 'MX':
    case 'NI':
    case 'PA':
    case 'PY':
    case 'PE':
    case 'GS':
    case 'UY':
    case 'VE':
      return 'https://www.youtube.com/@angelstudiosLATAM?sub_confirmation=1'
    default:
      return 'https://www.youtube.com/@angelstudiosinc?sub_confirmation=1'
  }
}
